import { combineReducers } from "@reduxjs/toolkit";
import displayProcedures from "./displayProceduresSlice";

const reducer = combineReducers({
  displayProcedures,
});

export default reducer;
